import { createAction } from 'redux-actions'

export const setSelectedRetailerId = createAction(
  'ASSIGN_RETAILER_ACCOUNT_MODAL/SET_SELECTED_RETAILER_ID',
)
export const changeRetailerContactEmail = createAction(
  'ASSIGN_RETAILER_ACCOUNT_MODAL/CHANGE_RETAILER_CONTACT_EMAIL',
)
export const changeRetailerId = createAction(
  'ASSIGN_RETAILER_ACCOUNT_MODAL/CHANGE_RETAILER_ID',
)
export const changeRetailerSearchText = createAction(
  'ASSIGN_RETAILER_ACCOUNT_MODAL/CHANGE_RETAILER_SEARCH_TEXT',
)
